module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Medium-Alphabetic.f0139e7d.woff";